import cx from 'classnames';
import React from 'react';
import styles from './TabItem.module.scss';
export const TabItem = ({ className, activeTabId, onClickTab, tab, }) => {
    const { id, label, url } = tab;
    const classes = cx(styles.button, {
        [styles.button__selected]: activeTabId === id,
    }, className);
    return (<li className={styles.tab}>
      {url ? (<a href={url} className={classes} onClick={() => onClickTab(tab)}>
          {label}
        </a>) : (<button className={classes} type='button' onClick={() => onClickTab(tab)}>
          {label}
        </button>)}
    </li>);
};
